import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "../Compartido/useHorizontalCarousel";

const Destinos = ({ destinos, ruta, lang }) => {

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bhh-property', destinos.length);

    const stripAndTruncate = (html, max = 130) => {
        if (!html) return "";
        const texto = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return texto.length > max ? texto.slice(0, max).trimEnd() + "…" : texto;
    };

    const showArrows = destinos.length > 4;

    {/* ************* */ }

    return (
        <div className="potblur bhh-destinos">
            <div className="bhh-section__head">
                <span className="bhh-eyebrow">{t("Dónde alojarte")}</span>
                {
                    destinos.length > 1 ?
                        <h2 className="text-center">{t("Nuestros destinos")}</h2>
                        :
                        <h2 className="text-center">{destinos[0].elnombre}</h2>
                }
            </div>

            <div className="bhh-destinos__carousel">
                {showArrows && (
                    <button
                        type="button"
                        disabled={navState.atStart}
                        onClick={() => scrollByCard(-1)}
                        className="bhh-destacados__prev"
                        aria-label={t("Anterior")}
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                    </button>
                )}
                <div className={"bhh-destinos__track" + (showArrows ? "" : " bhh-destinos__track--center")} ref={trackRef}>
                    {destinos.map((undestino, index) => {
                        const href = "/" + preidioma + t("apartamentos") + "-" + undestino.laurl;
                        const imagen = undestino.imagen_principal.length > 0
                            ? ruta + "/destinos/" + undestino.id + "/" + undestino.imagen_principal[0].imagen
                            : "/images/web/bedloop-nofoto.png";
                        const descripcion = stripAndTruncate(undestino.descripcion_corta);
                        return (
                            <div className="destacats-propietat bhh-property" key={index}>
                                <div className="bhh-property__card">
                                    <a href={href} className="bhh-property__media">
                                        <img className="destacats-imatge-propietat" src={imagen} alt={undestino.elnombre} loading="lazy" />
                                    </a>
                                    <div className="bhh-property__body">
                                        <h3 className="bhh-property__title"><a href={href}>{undestino.elnombre}</a></h3>
                                        {descripcion && <p className="bhh-property__desc">{descripcion}</p>}
                                        <a className="bhh-property__cta" href={href}>
                                            {t("Descubrir")}
                                            <i className="fa-solid fa-plus"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {showArrows && (
                    <button
                        type="button"
                        disabled={navState.atEnd}
                        onClick={() => scrollByCard(1)}
                        className="bhh-destacados__next"
                        aria-label={t("Siguiente")}
                    >
                        <i className="fa-solid fa-arrow-right"></i>
                    </button>
                )}
            </div>
        </div>
    )
}
export default Destinos;
